export default __webpack_public_path__ + "static/encryption01-ad0fa347abe122054244db137542db7f.jpg";